<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/S83VBw/tc-custom/9780374708214.jpg?1740712394117" alt="This image is the cover for the book Heart of Redness"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Heart of Redness
      </h1>
      <p class="bookDescription body article font2">
        <b>A South African man returns to a divided village in pursuit of lust, redemption, and identity in this “humorous, mythic, and complicated novel” (<i>San Francisco Chronicle</i>).</b><br/><br/>Having left for America during apartheid, Camugu has now returned to Johannesburg. Disillusioned by the problems of the new democracy, he follows his “famous lust” to Qolorha on the remote Eastern Cape. There in the nineteenth century a teenage prophetess named Nonqawuse commanded the Xhosa people to kill their cattle and burn their crops, promising that once they did so the spirits of their ancestors would rise and drive the occupying English into the ocean. The failed prophecy split the people in two, with devastating consequences.<br/><br/>One hundred fifty years later, the two groups’ decedents are at odds over plans to build a vast casino and tourist resort in the village, and Camugu is soon drawn into their heritage and their future—and into a bizarre love triangle as well.<br/><br/><b>“Brilliant . . . A new kind of novel: one that combines Gabriel García Márquez’s magic realism and political astuteness with satire, social realism and a critical reexamination of the South African past.” —<i>The New York Times Book Review</i></b><br/><br/><b>Shortlisted for the Commonwealth Writers Prize</b><br/><br/><b>A <i>New York Times</i> Notable Book</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zakes Mda
      </h2>
      
      <p class="authorDescription body article"><P><B>Zakes Mda</B>, a novelist and playwright, has received every major South African prize for his work. Born in 1948, he has been a visiting professor at Yale and the University of Vermont. He is writer-in-residence at the Market Theatre, Johannesburg. His previous novel, <I>Ways of Dying</I>, is available from Picador.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?244261d8